<template name="quickNotice">
  <div class="quick-notice">
    <div class="row noticeList">
      <div class="col-6 row list" v-for="(one, index) in this.noticeList">
        <div class="left col-8"><img :src="one.iconUrl"><span>{{one.title}}</span></div>
        <div class="right col-4" @click="sendMessage(one.typeId)"><span>发送通知</span></div>
      </div>
    </div>
    <alertModal :modalType="'simple'" :isModalShown="modalTip" :modalTitle="modalTipText" @cancel="closeModal"></alertModal>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
  </div>
</template>

<script type="text/javascript">
  import { sendQuickNotification, getQuickNotificationType } from '@/utils/api';
  import alertModal from '@/components/alertModal.vue';
  import { checkNested } from '@/utils/utils';
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  export default {
    name: 'quickNotice',
    components: {
      alertModal,
      Loading
    },
    data() {
      return {
        modalTip: false,
        modalTipText: '',
        noticeList: [],
        isLoading: false,
      }
    },
    created() {
      getQuickNotificationType().then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          if (res.data.content.model) {
            //console.log(res.data.content.model)
            this.noticeList = res.data.content.model;
          }
        }
      });
      document.body.addEventListener('touchstart', () => {});
    },
    methods: {
      sendMessage(typeId) {
        const MessageType = typeId;
        this.isLoading = true;
        sendQuickNotification(MessageType).then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            this.isLoading = false;
            if (res.data.content.model) {
              this.modalTip = true;
              this.modalTipText = '通知成功';
            } else {
              this.modalTip = true;
              this.modalTipText = res.data.content.message;
            }
          }
        });
      },
      closeModal() {
        this.modalTip = false;
        window.location.reload();
      }
    },
  }
</script>

<style lang="scss" scoped>
  .quick-notice {
    .noticeList {
      .list {
        background: #fff;
        box-shadow: 0 2px 11px 0 rgba(226, 226, 226, 0.35);
        height: 72px;
        border-radius: 4px;
        cursor: pointer;
        align-items: center;
        margin: 10px 0;
        & > div {
          margin: 0 !important;
          display: flex;
          align-items: center;
        }
        &:nth-of-type(2n) {
          padding-right: 0;
        }
        &:active,
        &:focus {
          .left {
            span {
              color: #4a4a4a;
              opacity: 0.8;
            }
          }
          .right {
            background-image: linear-gradient(56deg, #e04d2b, #c61820);
          }
        }
        .left {
          img {
            width: 36px;
            height: 36px;
          }
          span {
            font-size: 13px;
            color: #4a4a4a;
            padding-left: 10px;
            display: inline-block;
          }
        }
        .right {
          text-align: center;
          background-image: linear-gradient(54deg, #f36443, #e42029);
          height: 72px;
          line-height: 72px;
          border-radius: 0 4px 4px 0;
          justify-content: center;
          padding: 0;
          span {
            font-size: 14px;
            color: #ffffff;
          }
        }
      }
    }
    .row {
      margin: 0;
    }
    .list {
      background: #fff;
      height: 70px;
      border-radius: 4px;
      cursor: pointer;
      .list-left {
        width: 45%;
        background: #fff;
        box-shadow: 0 2px 11px 0 rgba(226, 226, 226, 0.35);
        height: 70px;
        align-items: center;
        &:active,
        &:focus {
          .left {
            span {
              color: #4a4a4a;
              opacity: 0.8;
            }
          }
          .right {
            background-image: linear-gradient(56deg, #e04d2b, #c61820);
          }
        }
        .left {
          padding-left: 20px;
          span {
            font-size: 13px;
            color: #4a4a4a;
            padding-left: 10px;
          }
        }
        .right {
          float: right;
          background-image: linear-gradient(54deg, #f36443, #e42029);
          height: 70px;
          line-height: 70px;
          border-radius: 0 4px 4px 0;
          span {
            font-size: 14px;
            color: #ffffff;
          }
        }
      }
      & > div:nth-of-type(2) {
        margin-left: 10%;
      }
      img {
        width: 36px;
        height: 36px;
      }
    }
    .listTow {
      margin-top: 30px;
    }
  }
</style>